// @generated by protobuf-ts 2.9.4 with parameter optimize_code_size,long_type_number,generate_dependencies
// @generated from protobuf file "Protos/comments.proto" (package "wuxiaworld.api.v2", syntax proto3)
// tslint:disable
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { Comments } from "./comments";
import type { GetCommentPageResponse } from "./comments";
import type { GetCommentPageRequest } from "./comments";
import type { GetCommentsResponse } from "./comments";
import type { GetCommentsRequest } from "./comments";
import type { Empty } from "../google/protobuf/empty";
import type { ReportCommentRequest } from "./comments";
import type { VoteCommentResponse } from "./comments";
import type { VoteCommentRequest } from "./comments";
import type { UpdateCommentResponse } from "./comments";
import type { UpdateCommentRequest } from "./comments";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { AddCommentResponse } from "./comments";
import type { AddCommentRequest } from "./comments";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service wuxiaworld.api.v2.Comments
 */
export interface ICommentsClient {
    /**
     * @generated from protobuf rpc: AddComment(wuxiaworld.api.v2.AddCommentRequest) returns (wuxiaworld.api.v2.AddCommentResponse);
     */
    addComment(input: AddCommentRequest, options?: RpcOptions): UnaryCall<AddCommentRequest, AddCommentResponse>;
    /**
     * @generated from protobuf rpc: UpdateComment(wuxiaworld.api.v2.UpdateCommentRequest) returns (wuxiaworld.api.v2.UpdateCommentResponse);
     */
    updateComment(input: UpdateCommentRequest, options?: RpcOptions): UnaryCall<UpdateCommentRequest, UpdateCommentResponse>;
    /**
     * @generated from protobuf rpc: VoteComment(wuxiaworld.api.v2.VoteCommentRequest) returns (wuxiaworld.api.v2.VoteCommentResponse);
     */
    voteComment(input: VoteCommentRequest, options?: RpcOptions): UnaryCall<VoteCommentRequest, VoteCommentResponse>;
    /**
     * @generated from protobuf rpc: ReportComment(wuxiaworld.api.v2.ReportCommentRequest) returns (google.protobuf.Empty);
     */
    reportComment(input: ReportCommentRequest, options?: RpcOptions): UnaryCall<ReportCommentRequest, Empty>;
    /**
     * @generated from protobuf rpc: GetComments(wuxiaworld.api.v2.GetCommentsRequest) returns (wuxiaworld.api.v2.GetCommentsResponse);
     */
    getComments(input: GetCommentsRequest, options?: RpcOptions): UnaryCall<GetCommentsRequest, GetCommentsResponse>;
    /**
     * @generated from protobuf rpc: GetCommentPage(wuxiaworld.api.v2.GetCommentPageRequest) returns (wuxiaworld.api.v2.GetCommentPageResponse);
     */
    getCommentPage(input: GetCommentPageRequest, options?: RpcOptions): UnaryCall<GetCommentPageRequest, GetCommentPageResponse>;
}
/**
 * @generated from protobuf service wuxiaworld.api.v2.Comments
 */
export class CommentsClient implements ICommentsClient, ServiceInfo {
    typeName = Comments.typeName;
    methods = Comments.methods;
    options = Comments.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: AddComment(wuxiaworld.api.v2.AddCommentRequest) returns (wuxiaworld.api.v2.AddCommentResponse);
     */
    addComment(input: AddCommentRequest, options?: RpcOptions): UnaryCall<AddCommentRequest, AddCommentResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<AddCommentRequest, AddCommentResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateComment(wuxiaworld.api.v2.UpdateCommentRequest) returns (wuxiaworld.api.v2.UpdateCommentResponse);
     */
    updateComment(input: UpdateCommentRequest, options?: RpcOptions): UnaryCall<UpdateCommentRequest, UpdateCommentResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateCommentRequest, UpdateCommentResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: VoteComment(wuxiaworld.api.v2.VoteCommentRequest) returns (wuxiaworld.api.v2.VoteCommentResponse);
     */
    voteComment(input: VoteCommentRequest, options?: RpcOptions): UnaryCall<VoteCommentRequest, VoteCommentResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<VoteCommentRequest, VoteCommentResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ReportComment(wuxiaworld.api.v2.ReportCommentRequest) returns (google.protobuf.Empty);
     */
    reportComment(input: ReportCommentRequest, options?: RpcOptions): UnaryCall<ReportCommentRequest, Empty> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<ReportCommentRequest, Empty>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetComments(wuxiaworld.api.v2.GetCommentsRequest) returns (wuxiaworld.api.v2.GetCommentsResponse);
     */
    getComments(input: GetCommentsRequest, options?: RpcOptions): UnaryCall<GetCommentsRequest, GetCommentsResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetCommentsRequest, GetCommentsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetCommentPage(wuxiaworld.api.v2.GetCommentPageRequest) returns (wuxiaworld.api.v2.GetCommentPageResponse);
     */
    getCommentPage(input: GetCommentPageRequest, options?: RpcOptions): UnaryCall<GetCommentPageRequest, GetCommentPageResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetCommentPageRequest, GetCommentPageResponse>("unary", this._transport, method, opt, input);
    }
}
